import React from 'react';
import { motion } from 'framer-motion';
export function Upsell() {
  return <section className="py-24 bg-gray-100 border-y-4 border-black" data-id="element-160">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-161">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-162">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex-1 w-full" data-id="element-163">
            <div className="border-4 border-black bg-white p-2" data-id="element-164">
              <img src="https://images.unsplash.com/photo-1521369909029-2afed882baee?w=800&q=80" alt="Custom printed cap with company logo" className="w-full h-auto object-cover grayscale hover:grayscale-0 transition-all duration-500" data-id="element-165" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex-1 w-full text-center md:text-left" data-id="element-166">
            <div className="inline-block bg-black text-white px-4 py-1.5 mb-6 font-display font-bold uppercase tracking-widest text-sm" data-id="element-167">
              Bundle & Save
            </div>
            <h2 className="md:text-5xl font-black mb-6 text-[36px]" data-id="element-168">
              Complete Your Brand — Add Custom Hats
            </h2>
            <p className="text-xl text-gray-600 mb-8 font-medium" data-id="element-169">
              Need custom hats too? We can quote trucker caps, snapbacks,
              beanies and more — just include them in your quote request.
            </p>
            <motion.button onClick={() => document.getElementById('quote-form')?.scrollIntoView({
            behavior: 'smooth'
          })} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="w-full sm:w-auto bg-black text-white px-8 py-4 font-display font-bold uppercase tracking-widest text-lg hover:bg-neutral-800 transition-colors" data-id="element-170">
              Add Hats to Your Quote
            </motion.button>
          </motion.div>
        </div>
      </div>
    </section>;
}